import {formatPrice} from '../common';

(function ($) {
  "use strict";
  $(function () {
    $(document).on('click', '.js-basket-menu-day-popup', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(document).find('.js-basket-menu-day-popup').removeClass('day_active');
      $(this).addClass('day_active');

      $(document).find('[data-basket-day]').hide();
      $(document).find('[data-basket-day="' + $(this).data('id') + '"]').show();
    });

    function initPopUpCalendar() {
      var basketPopupSlider = $(document).find('[data-entity="popup-basket-calendar"]');
      basketPopupSlider.slick('unslick');
      basketPopupSlider.slick({
        infinite: true,
        dots: false,
        arrows: false,
        slidesToScroll: 3,
        autoplay: false,
        autoplaySpeed: 5000,
        autoplayHoverPause: true,
        fade: false,
        touchThreshold: 14,
        swipeToSlide: true,
        slidesToShow: 3,
        responsive: [{breakpoint: 640, settings: {slidesToScroll: 5, slidesToShow: 5}}],
      })
    }

    if ($(document).find('[data-entity="popup-basket-calendar"]').length) {
      initPopUpCalendar();
    }

    $(document).on('click', '[data-action="basket-popup-delete-all"]', function () {
      let data = new FormData();
      let handler = $(this);
      let id = $(this).data('id');
      let action = 'delete_row';
      let dateItem = $(this).data('date');
      data.append('id', id);
      data.append('action', action);
      data.append('date', dateItem)
      $.ajax({
        method: 'POST',
        url: '/ajax/basketItem.php',
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function (result) {
          if (result.success) {
            window.reloadBasket(undefined, undefined, true, dateItem);
            removeItemWrapper(id);
            //updateData(result, handler, dateItem);
            window.listBasketItemsDay(true);
          }
        }
      });
    })

    $(document).on('click', '[data-action="popup-basket-add"]', function () {
      let data = new FormData();
      let handler = $(this);
      let id = $(this).data('id');
      let action = 'add',
        dateItem = $(this).data('date');
      data.append('id', id);
      data.append('action', action);
      data.append('date', dateItem)
      $.ajax({
        method: 'POST',
        url: '/ajax/basketItem.php',
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function (result) {
          if (result.success) {
            window.reloadBasket(undefined, undefined, true, dateItem);
            //setQuantity(id, action);
            //updateData(result, handler, dateItem);
            window.listBasketItemsDay(true);
          }
        }
      });
    });

    $(document).on('click', '[data-action="popup-basket-remove"]', function () {
      let data = new FormData();
      let id = $(this).data('id');
      let action = 'delete_one';
      let handler = $(this),
        dateItem = $(this).data('date');
      data.append('date', dateItem);
      data.append('id', id);
      data.append('action', action);
      $.ajax({
        method: 'POST',
        url: '/ajax/basketItem.php',
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'json',
        success: function (result) {
          if (result.success) {
            window.reloadBasket(undefined, undefined, true, dateItem);
            //setQuantity(id, action);
            //updateData(result, handler, dateItem);
            window.listBasketItemsDay(true);
          }
        }
      });
    });

    function setQuantity(id, action) {
      let block = $(document).find('[data-popup-quantity=' + id + ']');
      if (block.length) {
        if (action === 'add') {
          block.val(parseInt(block.val()) + 1);
        } else {
          if (block.val() > 1) {
            block.val(parseInt(block.val()) - 1);
          } else {
            removeItemWrapper(id);
          }
        }
      }
    }

    function removeItemWrapper(id) {
      $(document).find('[data-popup-basket-item=' + id + ']').fadeOut(100, function () {
        $(this).remove();
      });
    }

    function updateData(data, handler, datePopup) {
      let dayWrapper = handler.parents('[data-entity="popup-basket-day-wrapper"]');
      setTimeout(function () {
        $(document).find('[data-entity="popup-basket-summ"]').html(data.discount);
        if ($(document).find('[data-entity="popup-basket-days-count"]').length) {
          $(document).find('[data-entity="popup-basket-days-count"]').text(data.days);
          $(document).find('[data-entity="popup-basket-days-plural"]').text(getPlural(data.days));
        }

        if (dayWrapper.length) {
          if (data['current-date-total'] !== undefined) {
            let priceDay = formatPrice(data['current-date-total']);
            $(document).find('[data-popup-calendar-price="' + handler.data('date') + '"]').html(priceDay);
            if (data['deposit-current-date'] !== undefined) {
              $(document).find('[data-popup-deposit-amount="' + handler.data('date') + '"]').text(data['deposit-current-date']);
              $(document).find('[data-entity="popup-basket-summ"]').html(data['deposit-alldays-total']);
            }
          }
          if (dayWrapper.find('[data-entity="basket-popup-item"]:visible').length === 0) {
            if ($(document).find('[data-entity="popup-basket-day-wrapper"]').length === 1) {
              if ($(document).find('[data-entity="popup-basket-day-wrapper"]').find('[data-entity="basket-popup-item"]').length === 0)
              {
                $(document).find('.word').fadeOut(100, function () {
                  $(document).find(".word").attr("style", "");
                })
              }
            } else {
              let currentPan = $(document).find('[data-basket-popup-day="' + handler.data('date') + '"]');
              currentPan.fadeOut(100, function () {
                // currentPan.remove();
                initPopUpCalendar();
                let calendar = $(document).find('[data-entity="popup-basket-calendar"]');
                let slides = $(calendar.find('.month__slide:visible')[0]);
                if (
                  datePopup !== undefined
                  &&
                  datePopup !== ''
                ) {
                    if (calendar.find('.month__slide[data-basket-popup-day="' + datePopup + '"]').length) {
                      calendar.find('.month__slide[data-basket-popup-day="' + datePopup + '"]').find('a').click();
                    }
                } else {
                  slides.find('a').click();
                }
              })
            }
          }
        }
      }, 150);

    }

    function getPlural(i) {
      let decCases = [2, 0, 1, 1, 1, 2];
      let titles = ['день', 'дня', 'дней'];
      return titles[i % 100 > 4 && i % 100 < 20 ? 2 : decCases[Math.min(i % 10, 5)]];
    }

  })
})(jQuery);
